<template>
  <sidebar/>

  <navbar/>

  <main>
    <div v-if="urgentMessage" class="alert alert-danger m-4" v-html="urgentMessage"/>

    <slot/>
  </main>

  <impersonation v-if="isImpersonated" :name="user.name"/>

  <sprites/>
</template>

<script setup>
import {computed} from "vue";
import {usePage} from "@inertiajs/vue3";
import Sidebar from '@/components/Dashboard/Sidebar/Index'
import Navbar from '@/components/Dashboard/Navbar/Index'
import Impersonation from "@/components/Dashboard/Impersonation.vue";

const user = computed(() => usePage().props.user)
const urgentMessage = computed(() => usePage().props.urgentMessage)
const isImpersonated = computed(() => usePage().props.user.is_impersonated)
</script>

<style scoped>
.category-header {
  width: 94%;
  color: #00a8ff;
}

.add-button {
  top: 0;
  right: 0;
  width: 2rem;
  height: 2rem;
  font-size: 1.25rem;
  background-color: #4ed389;
  color: #ffffff;
  border-radius: 25px;
  text-align: center;
}

.inner-box.link {
  transition: all 0.5s ease;
}

.inner-box.link:hover {
  transform: translateY(-10px);
}

.inner-box {
  font-size: 14px;
}

.inner-box,
.arrows {
  min-height: 300px;
  max-height: 300px;
}

.arrows span {
  display: block;
  font-size: 70px;
  line-height: 32px;
  color: #4ed389;
  font-weight: bold;
}

.arrows span:first-child {
  color: var(--primary);
}

.active-tab {
  border-bottom: 3px solid var(--primary-50);
}

.ordering-arrows {
  font-size: 24px;
}

.arrow-up {
  display: inline-block;
  transform: rotate(90deg);
}

.arrow-down {
  display: inline-block;
  transform: rotate(90deg);
}
</style>
